import 'angular';

import '@popperjs/core';
import 'bootstrap';

import 'angular-animate';
import 'angular-cookies';
// import 'angular-dragula';
import 'angular-google-chart';
import 'angular-google-maps';
// import 'angular-hammer';
import 'angular-linkify';
import 'angular-local-storage';
import 'angular-material';
// import 'angular-material/angular-material.scss';
import 'angular-material-data-table';
import 'angular-messages';
// import 'angular-nvd3';
import 'angular-permission';
import 'angular-sanitize';
// import 'angular-signature';
// import 'angular-timeago';
import 'angular-translate';
import 'angular-translate-loader-partial';
import 'angular-translate-storage-cookie';
import 'angular-translate-storage-local';
import 'angular-ui-calendar';
import 'angular-ui-router';
// import 'angular-ui-tinymce';
import 'angular-ui-tree';
import 'angular-zxcvbn';
import 'angular-simple-logger';
import 'angular-moment';
import 'fullcalendar';
import 'iso-currency';
import 'jquery';
import 'lodash';
// import 'ng-material-datetimepicker';
import 'md-date-range-picker';
import 'moment';
import 'moment-timezone';
import 'ng-file-upload';
import 'phoneformat.js/dist/phone-format-global.js';
import 'rrule';
import 'satellizer';
import 'vis-timeline/dist/vis-timeline-graph2d.min';
import 'zxcvbn';
import 'flag-icons/sass/flag-icons.scss'

import './../static/intercome.js';
